export { API_BASE, UPLOADS_BASE } from "../../../api/config";
export const MEDICAL_SPECIALTY_TYPE_OPTIONS = ["Medicine", "Surgical"];
export const MVT_RELEVANCE_OPTIONS = ["Yes", "No"];
